import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({
  name: 'formError'
})
export class FormErrorPipe implements PipeTransform {
  transform(errors: ValidationErrors): string {
    return this.getErrorMessage(errors);
  }

  getErrorMessage(errors: ValidationErrors): string {
    if (!errors) {
      return;
    }

    if (errors.emailExists) {
      return 'This email already exists';
    }

    if (errors.maxLoadCount) {
      return (
        `Total loads prepared (${errors.maxLoadCount.totalCount}) cannot be ` +
        `greater than approved loads (${errors.maxLoadCount.approvedLoads})`
      );
    }
    if (errors.pattern) {
      return `Invalid entry`;
    }
    if (errors.matDatepickerMin) {
      return `Date must be greater than or equal to today`;
    }
    if (errors.duplicateBatchName) {
      return `Batch name '${errors.duplicateBatchName.name}' is already taken`;
    }
    if (errors.duplicateCompanyName) {
      return `Company name '${errors.duplicateCompanyName.name}' is already taken`;
    }
    if (errors.matDatepickerParse) {
      return 'Invalid Date';
    }
    if (errors.uploadRequired) {
      return `Document upload required`;
    }
    if (errors.minUploadCount) {
      const { length } = errors.minUploadCount;
      return `At least ${length} documents required`;
    }
    if (errors.maxUploadCount) {
      const { length } = errors.maxUploadCount;
      return `Cannot upload more than ${length} documents`;
    }
    if (errors.maxFieldLength) {
      return `No more than ${errors.maxFieldLength.length} characters`;
    }
    if (errors.minlength) {
      const { requiredLength } = errors.minlength;
      return `At least ${requiredLength} characters are required`;
    }
    if (errors.maxlength) {
      const { requiredLength } = errors.maxlength;
      return `No more than ${requiredLength} characters are required`;
    }
    if (errors.min) {
      const { min } = errors.min;
      return `Value must be greater than ${min}`;
    }
    if (errors.max) {
      const { max } = errors.max;
      return `Value must be less than ${max}`;
    }
    if (errors.url) {
      return 'Url is invalid';
    }
    if (errors.email) {
      return 'Email is invalid';
    }
    if (errors.required) {
      return 'Required';
    }
    if (errors.numberExists) {
      return 'This number already exists';
    }
    if (errors.whitespace) {
      return 'This field cannot be left blank';
    }
    if (errors.oneIsRequired) {
      return 'Estimated Weight or Estimated Volume Must be filled';
    }
  }
}
